const baseInputStyles = (theme) => ({
  backgroundColor: 'transparent',
  fontFamily: 'var(--root-font) !important',
  width: '100%',
  border: 'none',
  '&:focus': {
    outline: 'none'
  },
  '&::placeholder': {
    opacity: '0.2',
    fontWeight: 'bold'
  }
})

const sizes = {
  xs: (theme) => ({
    padding: '2px 6px 2px 6px',
    minHeight: '18px',
    '& > input': {
      ...baseInputStyles(theme),
      lineHeight: '18px',
      fontSize: theme.typography.fontSizes.md
    }
  }),
  sm: (theme) => ({
    padding: '2px 10px 2px 10px',
    minHeight: '32px',
    '& > input': {
      ...baseInputStyles(theme),
      lineHeight: '32px',
      fontSize: theme.typography.fontSizes.xl
    }
  }),
  lg: (theme) => ({
    padding: '9px 10px 9px 15px',
    minHeight: '32px',
    '& > input': {
      lineHeight: '32px',
      ...baseInputStyles(theme),
      fontSize: theme.typography.fontSizes.xl
    }
  })
}

export const mapInputStyles = (theme, rest) => ({ disabled, size, minWidth, width }) => ({
  ...rest,
  ...sizes[size](theme),
  backgroundColor: disabled ? 'var(--color-neutral-200)' : 'var(--color-surface-050)',
  color: disabled ? 'var(--color-neutral-500)' : 'var(--text-color-main)',
  ...(minWidth && { minWidth }),
  ...(width && { width })
})
